import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const OrganicPadsSupportWomensHealth = () => {
  useMetaTags({
    title: "How Organic Pads Support Women's Health | Natural & Chemical-Free Menstrual Care",
    description: "Discover how organic pads help protect women's reproductive health, hormone balance, and overall wellness. Switch to natural, chemical-free menstrual care for a healthier lifestyle.",
    keywords: "organic pads, women's health, chemical-free sanitary pads, reproductive health, hormone balance, menstrual care, natural period products",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/organic-pads-womens-health",
    ogTitle: "How Organic Pads Support Women's Health",
    ogDescription: "Organic pads protect women's reproductive health, maintain hormone balance, and enhance overall wellness. Switch to natural, chemical-free menstrual care for a healthier lifestyle.",
    ogImage: "https://plus.unsplash.com/premium_photo-1702598845073-282b7c56da37?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZmVtYWxlJTIwaHlnaW5lJTIwbWVuc3RydWFsJTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D",
    ogUrl: "https://organicpads.shop/organic-pads-womens-health",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "How Organic Pads Support Women's Health",
    twitterDescription: "Organic pads help balance hormones, support reproductive health, and improve overall well-being. Make the switch to natural menstrual care today.",
    twitterImage: "https://plus.unsplash.com/premium_photo-1702598845073-282b7c56da37?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZmVtYWxlJTIwaHlnaW5lJTIwbWVuc3RydWFsJTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/organic-pads-womens-health"
    },
    "headline": "How Organic Pads Support Women's Health",
    "description": "Discover how organic pads help protect women's reproductive health, hormone balance, and overall wellness. Switch to natural, chemical-free menstrual care for a healthier lifestyle.",
    "image": "https://plus.unsplash.com/premium_photo-1702598845073-282b7c56da37?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZmVtYWxlJTIwaHlnaW5lJTIwbWVuc3RydWFsJTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "organic pads",
      "women's health",
      "chemical-free sanitary pads",
      "reproductive health",
      "hormone balance",
      "menstrual care",
      "natural period products"
    ]
  }  

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        How Organic Pads Support Women's Health
      </h1>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598845073-282b7c56da37?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZmVtYWxlJTIwaHlnaW5lJTIwbWVuc3RydWFsJTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D"
        alt="Women's Health"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Women's health is intimately connected to the products we use during menstruation. Organic pads support overall wellness by eliminating exposure to harmful chemicals and providing natural, body-friendly protection.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Health Benefits</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Hormone balance protection</li>
        <li>Reproductive health support</li>
        <li>Skin health promotion</li>
        <li>Natural pH maintenance</li>
        <li>Overall wellness enhancement</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Prioritize Your Health?</h2>
      <p className="text-gray-700 mb-4">
        Select <strong>certified organic</strong> products that prioritize women's health. Regular health check-ups complement the benefits of using organic menstrual products.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Health Support"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Your health deserves the best care possible.
        <strong> Choose organic for better wellness!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default OrganicPadsSupportWomensHealth;
